(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  let variants = [];
  try {
    variants = JSON.parse(section.querySelector('[data-product-variants]')?.textContent || '[]');
  } catch (_) {
    return;
  }
  if (!variants.length) return;

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase();
  const modelFromValue = (value) => {
    const v = normalize(value);
    if (v === 'standard' || v.includes('no vacuum')) return 'standard';
    if (v === 'pro' || (v.includes('vacuum') && !v.includes('no vacuum'))) return 'pro';
    return '';
  };

  const optionGroups = Array.from(section.querySelectorAll('[data-product-option-group]'));
  const modelGroup = optionGroups.find((group) => {
    const models = Array.from(group.querySelectorAll('[data-product-option]')).map((input) => modelFromValue(input.value));
    return models.includes('standard') && models.includes('pro');
  });
  if (!modelGroup) return;

  const modelIndex = Number(modelGroup.dataset.optionIndex || 0);
  const modelInputs = Array.from(modelGroup.querySelectorAll('[data-product-option]'));
  const inputForModel = (model) => modelInputs.find((input) => modelFromValue(input.value) === model);
  const standardInput = inputForModel('standard');
  const proInput = inputForModel('pro');
  if (!standardInput || !proInput) return;

  const variantForInput = (input) => variants.find((variant) => variant.options?.[modelIndex] === input?.value);
  const standardVariant = variantForInput(standardInput);
  const proVariant = variantForInput(proInput);

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: window.KABO.currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} €`;
    }
  };

  const subtitleNodes = Array.from(section.querySelectorAll('[data-kabo-product-subtitle]'));
  const subtitleSource = subtitleNodes[0];
  const subtitleForModel = (model) => {
    if (!subtitleSource) return '';
    return model === 'pro'
      ? (subtitleSource.dataset.kaboSubtitlePro || subtitleSource.dataset.kaboSubtitleDefault || '')
      : (subtitleSource.dataset.kaboSubtitleStandard || subtitleSource.dataset.kaboSubtitleDefault || '');
  };

  const syncBenefitSubtitle = (model) => {
    const text = subtitleForModel(model);
    if (!text) return;
    subtitleNodes.forEach((subtitle) => {
      subtitle.textContent = text;
    });
  };

  const form = section.querySelector('[data-kabo-product-form]');
  const productOptions = section.querySelector('.product-options');
  if (!form || !productOptions) return;

  const picker = document.createElement('fieldset');
  picker.className = 'grill-model-picker kabo-turboair-model-picker';
  picker.innerHTML = `
    <legend class="field-label">Modell <span data-turboair-model-current></span></legend>
    <div class="grill-model-picker__options">
      <div class="grill-model-picker__option">
        <input class="variant-pill__input visually-hidden" type="radio" id="TurboAirModel-standard" name="turboair-model" value="standard" data-turboair-model-input${standardVariant?.available === false ? ' disabled' : ''}>
        <label class="grill-model-picker__card" for="TurboAirModel-standard">
          <span class="grill-model-picker__details"><span class="grill-model-picker__title">Standard</span><span class="grill-model-picker__description">Blasfunktion · kompakt & kabellos</span></span>
          <strong class="grill-model-picker__price">${formatMoney(standardVariant?.price)}</strong>
        </label>
      </div>
      <div class="grill-model-picker__option">
        <input class="variant-pill__input visually-hidden" type="radio" id="TurboAirModel-pro" name="turboair-model" value="pro" data-turboair-model-input${proVariant?.available === false ? ' disabled' : ''}>
        <label class="grill-model-picker__card" for="TurboAirModel-pro">
          <span class="grill-model-picker__details"><span class="grill-model-picker__title">Pro</span><span class="grill-model-picker__description">Blas- + Saugfunktion</span></span>
          <strong class="grill-model-picker__price">${formatMoney(proVariant?.price)}</strong>
        </label>
      </div>
    </div>`;

  productOptions.before(picker);
  modelGroup.hidden = true;
  modelGroup.classList.add('variant-group--single');
  if (!optionGroups.some((group) => !group.hidden && !group.classList.contains('variant-group--single'))) {
    productOptions.classList.add('product-options--empty');
  }

  const pickerInputs = Array.from(picker.querySelectorAll('[data-turboair-model-input]'));
  const currentLabel = picker.querySelector('[data-turboair-model-current]');

  const syncModel = (model) => {
    pickerInputs.forEach((input) => { input.checked = input.value === model; });
    if (currentLabel) currentLabel.textContent = model === 'pro' ? 'Pro' : 'Standard';
    section.querySelectorAll('[data-turboair-model-only]').forEach((element) => {
      element.hidden = element.dataset.turboairModelOnly !== model;
    });
    syncBenefitSubtitle(model);
  };

  const selectModel = (model, updateUrl = true) => {
    const sourceInput = model === 'pro' ? proInput : standardInput;
    const pickerInput = pickerInputs.find((input) => input.value === model);
    if (!sourceInput || sourceInput.disabled || pickerInput?.disabled) return;
    sourceInput.checked = true;
    sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    syncModel(model);
    if (updateUrl && history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('model', model);
      history.replaceState({}, '', url);
    }
  };

  pickerInputs.forEach((input) => input.addEventListener('change', () => input.checked && selectModel(input.value)));
  modelInputs.forEach((input) => input.addEventListener('change', () => input.checked && syncModel(modelFromValue(input.value))));

  const description = section.querySelector('.product-description.rte');
  if (description) description.classList.add('product-description--turboair');

  const modelParameters = new URL(window.location.href).searchParams;
  const requestedModel = modelParameters.get('model');
  const checkedModel = modelFromValue(modelInputs.find((input) => input.checked)?.value);
  const requestedInitialModel = requestedModel === 'standard' || requestedModel === 'pro'
    ? requestedModel
    : (modelParameters.has('variant') ? checkedModel : 'standard');
  const initialModel = requestedInitialModel === 'standard' && (standardInput.disabled || standardVariant?.available === false)
    ? 'pro'
    : (requestedInitialModel || (standardInput.disabled ? 'pro' : 'standard'));
  selectModel(initialModel, false);
})();
